"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var replaceTranslation = function replaceTranslation(text, data) {
  if ((0, _isEmpty.default)(data)) return text;
  var regex = /\{{(.*?)\}}/g;
  var result = text.replace(regex, function () {
    var _data$key;

    var key = arguments.length <= 1 ? undefined : arguments[1];
    return (_data$key = data === null || data === void 0 ? void 0 : data[key]) !== null && _data$key !== void 0 ? _data$key : arguments.length <= 0 ? undefined : arguments[0];
  });
  return result;
};

var _default = replaceTranslation;
exports.default = _default;